/* These roughly correlate to bootstrap's sass media queries */
export default {
  computed: {
    screenIsSmUp() {
      return ['sm', 'md', 'lg', 'xl'].includes(this.$mq);
    },
    screenIsMdUp() {
      return ['md', 'lg', 'xl'].includes(this.$mq);
    },
    screenIsLgUp() {
      return ['lg', 'xl'].includes(this.$mq);
    },
    screenIsXlUp() {
      return ['xl'].includes(this.$mq);
    },
    screenIsSmDown() {
      return ['xs', 'sm'].includes(this.$mq);
    },
    screenIsMdDown() {
      return ['xs', 'sm', 'md'].includes(this.$mq);
    },
    screenIsLgDown() {
      return ['xs', 'sm', 'md', 'lg'].includes(this.$mq);
    },
    screenIsXsDown() {
      return ['xs'].includes(this.$mq);
    },
  },
};
